import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=6cb34200&"
import script from "./placeholder.vue?vue&type=script&lang=js&"
export * from "./placeholder.vue?vue&type=script&lang=js&"
import style0 from "./placeholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports